import type { PaginationQuery, TopupPage } from '@ytclip/shared'
import { topupPageSchema } from '@ytclip/shared'
import { apiRequest } from '@/lib/api-client.ts'

export function fetchTransactions(query: PaginationQuery): Promise<TopupPage> {
  return apiRequest('/me/transactions', topupPageSchema, {
    query: { page: query.page, pageSize: query.pageSize },
  })
}
